import { call, put, select, takeEvery } from "redux-saga/effects";
import { fetchAccountCompetitors, fetchAccountDetails, fetchAccountInfo, fetchClientProductOpportunities } from "../../../services/accIqService";
import { FETCH_ACCOUNT_DETAILS_REQUEST, FETCH_ACCOUNT_INFO_REQUEST, fetchAccountDetailsFailure, fetchAccountDetailsSuccess, fetchAccountInfoFailure, fetchAccountInfoSuccess } from "../actions/accountsActions";
import { getAccountDetails } from "../../../services/commonService";

function* fetchAccountInfoSaga(action) {
  try {
    const { accountName, params } = action.payload;
    const account_info = yield call(fetchAccountInfo, accountName);
    const response = yield call(getAccountDetails,params);

    account_info.db_details = response?.data?.result?.list?.[0] || {};

    const sortedData = account_info?.business_units?.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      const isOtherA = nameA === "other" || nameA === "others";
      const isOtherB = nameB === "other" || nameB === "others";

      if (isOtherA && !isOtherB) return 1;
      if (isOtherB && !isOtherA) return -1;

      return b.revenue - a.revenue;
    });

    account_info.business_units = sortedData;

    yield put(fetchAccountInfoSuccess(account_info));
  } catch (error) {
    yield put(fetchAccountInfoFailure(error));
  }
}

function* fetchAccountDetailsSaga(action) {
  try {
    /*
    const { accountId, accountName, clientName } = action.payload;
    const account_details = yield call(fetchAccountDetails, accountId, accountName, clientName);
    const competitorsResult = yield call(fetchAccountCompetitors, accountId, accountName, clientName);
    account_details.competitors = competitorsResult?.competitors || [];

    const client_product_opportunities = yield call(fetchClientProductOpportunities, accountId, accountName, clientName);
    account_details.client_product_opportunities = client_product_opportunities || [];

    const {account_info} = yield select(state=>state?.accountsReducer)

    const bu_order = account_info?.business_units?.reduce((acc, bu, index) => {
      acc[bu.name.trim()] = index;
      return acc;
    }, {});

    if(bu_order){
      account_details?.key_products_services?.sort((a, b) => {
          return bu_order[a.bu_name.trim()] - bu_order[b.bu_name.trim()];
      });
    }
    */
    const account_details = {}
    yield put(fetchAccountDetailsSuccess(account_details));
  } catch (error) {
    yield put(fetchAccountDetailsFailure(error));
  }
}

export function* watchFetchAccountInfo() {
  yield takeEvery(FETCH_ACCOUNT_INFO_REQUEST, fetchAccountInfoSaga);
}

export function* watchFetchAccountDetails() {
  yield takeEvery(FETCH_ACCOUNT_DETAILS_REQUEST, fetchAccountDetailsSaga);
}